import React, { useEffect, useState } from "react";

import { ReactComponent as ArrowUp } from "../../../assets/icons/arrow-up-right.svg";
import { Link, useNavigate } from "react-router-dom";

const CBRFormat: React.FC = () => {
  const [joinDetails, setjoinDetails] = useState([
    {
      course_duration: "",
      description: "",
      course_mode: "",
      heading: "",
      title: "",
      registration_form_link: "",
      image: {
        url: "",
      },
    },
  ]);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/api/cbr-courses?populate=*", {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setjoinDetails(data?.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const navigate = useNavigate();

  return (
    <div className="container mx-auto py-12">
      <div className="container mx-auto px-4 lg:px-16 text-center mb-16">
        <p className="text-navYellow font-medium tracking-wider text-xl mb-3">Course Options</p>
        <h2 className="text-3xl md:text-4xl font-semibold text-darkBlue mb-3 ">
          Choose Your Preferred Course Format
        </h2>
        <p className="text-gray-600 text-lg mb-3 leading-relaxed">The same transformative course, offered in different formats to suit your unique context and needs.</p>
      </div>

      <div className="flex items-stretch justify-between flex-wrap">
        {joinDetails.map((detail) => (
          //<div className="w-[327px] md:w-[30%]">
          <div className="max-w-sm my-2 rounded-lg overflow-hidden shadow-lg w-full bg-white">
            <div className="relative h-60">
              <img
                src={detail?.image?.url}
                alt={detail?.title}
                className="w-full h-full object-cover"
              />

              <div className="absolute w-full bottom-0 px-3 z-10 py-2 backdrop-blur-md">
                <div className="flex justify-between items-center">
                  {/* Left side text */}
                  <div className="p-1 rounded-lg  ">
                    <p className="text-sm font-bold text-white">
                      {detail?.title}
                    </p>
                    <p className="text-sm font-normal text-white">
                      {detail?.course_duration}
                    </p>
                  </div>
                  {/* Right side text */}
                  <div className="text-white px-3 py-2">
                    <span className="text-sm font-medium">
                      {detail?.course_mode}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Content Section */}
            <div className="relative p-6 bg-white">
              <h2 className="text-xl font-medium mb-4">{detail?.heading}</h2>
              <p className="text-gray-600 text-sm mb-6">
                {detail?.description}
              </p>

              {/* Contact Link */}
              <div className="absolute bottom-2 flex items-center text-deepBlue cursor-pointer">
                {detail?.registration_form_link ? (
                  <>
                    <a href={detail.registration_form_link} target="_blank" rel="noopener noreferrer" className="mr-1 hover:underline">
                      Register
                    </a>
                    <ArrowUp />
                  </>
                ) : (
                  <>
                    <Link to="/contacts" className="mr-1 hover:underline">Contact us</Link>
                    <ArrowUp />
                  </>
                )}
              </div>

            </div>
          </div>
          //</div>
        ))}
      </div>

      <div className="mt-16 bg-white border border-gray-200 rounded-xl p-4">
        <span className="font-semibold text-darkBlue">Flexible Learning:</span>
        <p className="text-gray-700 text-base mt-1">The CBR course can be completed alongside your regular schedule, work, or studies. It is designed to integrate seamlessly into your daily life.</p>
      </div>
    </div>
  );
};

export default CBRFormat;
